import React from "react";
import style from "../style/styled.module.css";
const StyledDiv = ({ children }) => <div className={style.box}>{children}</div>;

export default StyledDiv;
